import React from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { TextFieldMultiline } from "Components/Base/Inputs/TextFieldMultiline";
import { Box } from "Components/Base/Layout/Box";
import {
  MetadataRequiredMark,
  metadataFieldErrorFormHelperTextProps,
} from "lib/components/ItemMetadataFields/fields/shared";

const MultipleField = ({ field, fieldState, disabled, onChange }) => {
  const { fieldError, fieldId, labelText, required, value } = fieldState;

  return (
    <Box mb={1.25}>
      <Typography component="label" htmlFor={fieldId} variant="body1">
        {labelText}
        {required ? <MetadataRequiredMark /> : null}
      </Typography>
      <TextFieldMultiline
        id={fieldId}
        minRows={3}
        fullWidth
        disabled={disabled}
        value={value}
        error={Boolean(fieldError)}
        helperText={fieldError}
        FormHelperTextProps={metadataFieldErrorFormHelperTextProps}
        onChange={(event) => onChange(field.id, event.target.value)}
        inputProps={{
          maxLength: 4000,
          "aria-required": required ? "true" : "false",
          "aria-invalid": fieldError ? "true" : "false",
        }}
      />
    </Box>
  );
};

export default MultipleField;
